// 聊天配置
export default {
  // 视频上传大小限制（MB）
  videoMaxSize: 50
}
